import { render } from "./TabsPage.vue?vue&type=template&id=5b3c92d3"
import script from "./TabsPage.vue?vue&type=script&lang=js"
export * from "./TabsPage.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__